<template>
    <v-layout wrap py-4 align-center>
        <v-flex v-if='status' :class="{
            'xl8 lg6': status == 'status_processing'
        }"
        >
            <v-layout wrap align-center>
                <div>
                    <div class="mr-4">
                        <labelTopic :class="status.bg_color" class="section-label--green">{{ $t(status.text) }}</labelTopic>
                    </div>
                </div>
                <!-- <div v-if="status.status !== 'status_processing'" class="switcher mt-2 pr-5 text-lg-center">
                <v-switch
                    v-model="model_modal_status"
                    :label="$t('Активность организации')"
                    :value="status.status == 'status_confirmed'"
                />
            </div> -->
                <v-flex xs10 :class="{
                    'xs12': $vuetify.breakpoint.width < 400
                }"
                >
                    <v-layout wrap align-start>
                        <div v-if="permission" class="mt-2 mr-4">
                            <linkIcon icon="edit" class="text-lg-center" @click.native="OPEN_MODAL('company_info')">
                                {{ $t("Редактировать профиль организации") }}
                            </linkIcon>
                            <v-dialog :value="company_info.active" persistent content-class="scrolled-dialog">
                                <companyEditAdmin v-if="company_info.active" :status_access="status_access"
                                                  :company_page="company_page"
                                />
                            </v-dialog>
                        </div>

                        <v-flex v-if="available_annual_certificates && available_annual_certificates.length > 0" xs12
                                sm6 class="mt-2"
                        >
                            <v-select
                                solo
                                attach
                                :items="available_annual_certificates"
                                item-value="id"
                                item-text="name"
                                append-icon=""
                                class="download_certificate"
                                :value="false"
                                :single-line="true"
                                :menu-props="{ bottom: true, offsetY: true }"
                                @input="download_annual_certificate"
                            >
                                <template #append>
                                  <v-icon aria-hidden="true" translate="no">
                                    expand_more
                                  </v-icon>
                                </template>
                                <template slot="label">
                                    <linkIcon size="40px" :icon="'cert'" class="text-lg-center">
                                        {{ $t('Сертификаты о достижении компании уровня «Эксперт»') }}
                                    </linkIcon>
                                </template>
                                <template slot-scope="props" slot="selection">
                                    <linkIcon size="40px" :icon="'cert'" class="text-lg-center">
                                        {{ $t('Сертификаты о достижении компании уровня «Эксперт»') }}
                                    </linkIcon>
                                </template>
                            </v-select>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex v-if='status && status_access' :class="{
            'xl4 lg6': !available_annual_certificates.length,
            'xs12 mt-4': available_annual_certificates.length > 0
        }"
        >
            <v-layout v-if="status.status == 'status_processing'" row wrap
                      align-start
                      :class="{
                          'justify-end': $vuetify.breakpoint.mdAndUp && !available_annual_certificates.length,
                          'justify-start': available_annual_certificates.length > 0
                      }"
            >
                <buttonRed class="mt-3 mr-3" @click.native="accept_org()">{{ $t("Одобрить организацию") }}</buttonRed>
                <buttonBdWhite class="mt-3" @click.native="reject_org()">{{ $t("Отклонить организацию") }}</buttonBdWhite>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
import linkIcon from '@/components/ui/links/with_icon/link_sprite_icon';
import labelTopic from '@/components/ui/labels/label_topic';
import buttonRed from '@/components/ui/buttons/button_red';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import companyEditAdmin from '@/components/view_blocks/Company_profile/Company_modals/Company_edit_admin';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    linkIcon,
    labelTopic,
    companyEditAdmin,
    buttonRed,
    buttonBdWhite,
  },
  props: {
    company_page: {
      type: Object,
    },
    status_access: {
      type: Boolean,
    },
  },
  data() {
    return {
      data_status: true,
    };
  },
  computed: {
    ...mapGetters('company_profile', [
      'other_active_status',
      'available_annual_certificates',
    ]),
    ...mapGetters('company_profile/info', [
      'company_id',
      'company_statuses',
      'active_status',
    ]),
    ...mapGetters('company_profile/modals', [
      'company_info',
      'get_modal_status',
    ]),
    ...mapGetters('profile/user', [
      'user',
    ]),
    model_modal_status: {
      get() {
        if (this.status && this.status == 'status_confirmed') {
          return true;
        } else return false;
      },
      set($event) {
        if ($event) {
          return this.accept_org();
        } else {
          return this.disable_org();
        }
      },
    },
    permission() {
      return ['ADMINISTRATOR', 'ORGANIZATION_ADMINISTRATOR'].includes(this.user.role_code) || !this.$route.params.id;
    },
    status() {
      if (this.active_status) {
        return this.active_status;
      } else {
        return this.other_active_status;
      }
    },
  },
  methods: {
    ...mapActions('company_profile/info', ['submit_company']),
    ...mapMutations('company_profile/info', ['SET_COMPANY_STATUS']),
    ...mapMutations('company_profile/modals', ['OPEN_MODAL']),
    accept_org() {
      this.SET_COMPANY_STATUS('status_confirmed');
      this.submit_company();
    },
    reject_org() {
      this.SET_COMPANY_STATUS('status_rejected');
      this.submit_company();
    },
    disable_org() {
      this.SET_COMPANY_STATUS('status_disabled');
      this.submit_company();
    },
    async download_annual_certificate(id) {
      let win = window.open(`/api/certificate/annual/company/${id}`, '_blank');
      win.focus();
    },
  },
};
</script>

